export default {
    API_URL: import.meta.env.VITE_REACT_APP_API_URL ?? 'http://localhost:3000/api',
    AUTH_TOKEN_KEY: import.meta.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY ?? 'auth_key'
};